<template>
  <v-container class="fill-height" fluid>
    <v-row justify="center">
      <v-col cols="12" sm="10" md="6" xl="4">
        <v-card class="pa-5" style="opacity: 0.88">
          <v-card-text>
            <div class="product Box-root">
              <div class="description Box-root">
                <h3>Checkout canceled!</h3>
              </div>
            </div>
            Picked the wrong subscription? Try again by choosing different subscription plan!
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn text type="button" to="/plans">Select Plan</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Logo from "./Logo.vue"

export default {
  name: "CancelledDisplay",
  props: {
    
  },
  components: {
  },
}
</script>

<style scoped>
/* Add your styles here */
</style>
